import { navigateToPermissionsTab, ROUTE_PERMISSIONS } from '@shared';

export { ROUTE_PERMISSIONS };

export const navigateToTab = navigateToPermissionsTab;
